export default __webpack_public_path__ + "static/media/checkoutviewmobile.c1d411e4.png";